import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { WebPageSchema, BreadcrumbListSchema } from '@/components/feature/SchemaOrg';
import { articles } from '@/mocks/siteData';

const articleImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=Luxury%20dark%20themed%20abstract%20illustration%20with%20golden%20trophy%20concept%2C%20elegant%20geometric%20patterns%20with%20warm%20amber%20accents%2C%20premium%20atmospheric%20composition%2C%20award%20celebration%20theme%2C%20cinematic%20lighting%2C%20dark%20background%20with%20gold%20highlights&width=800&height=480&seq=article-award-01&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=Modern%20dark%20abstract%20cybersecurity%20illustration%20with%20golden%20shield%20concept%2C%20elegant%20geometric%20lock%20patterns%2C%20warm%20amber%20accents%20on%20dark%20background%2C%20premium%20corporate%20security%20theme%2C%20cinematic%20lighting&width=800&height=480&seq=article-security-01&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=Elegant%20dark%20abstract%20illustration%20with%20golden%20gift%20box%20and%20celebration%20theme%2C%20luxurious%20atmospheric%20composition%20with%20warm%20amber%20particles%2C%20promotion%20and%20welcome%20bonus%20concept%2C%20cinematic%20lighting%20on%20dark%20background&width=800&height=480&seq=article-promo-01&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=Modern%20dark%20abstract%20digital%20currency%20illustration%20with%20golden%20circuit%20patterns%2C%20blockchain%20network%20concept%2C%20elegant%20geometric%20design%20with%20amber%20accents%2C%20fintech%20payment%20theme%2C%20cinematic%20dark%20background&width=800&height=480&seq=article-payment-01&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=Luxury%20dark%20abstract%20VIP%20membership%20illustration%20with%20golden%20crown%20concept%2C%20premium%20diamond%20geometric%20patterns%2C%20warm%20amber%20highlights%20on%20elegant%20dark%20background%2C%20exclusive%20club%20theme%2C%20cinematic%20lighting&width=800&height=480&seq=article-vip-01&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=Elegant%20dark%20abstract%20illustration%20with%20balanced%20scales%20concept%2C%20golden%20harmony%20patterns%2C%20responsible%20and%20ethical%20theme%2C%20warm%20amber%20accents%20on%20premium%20dark%20background%2C%20corporate%20social%20responsibility&width=800&height=480&seq=article-responsible-01&orientation=landscape',
};

export default function ArticlesPage() {
  return (
    <>
      <ScrollToTop />
      <WebPageSchema
        title="最新资讯 - 开云官网"
        description="了解开云平台最新动态、安全公告、优惠活动与技术更新。关注开云官网资讯频道，获取第一手平台信息。"
        url="https://www.kaiyun.com/articles"
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://www.kaiyun.com/' },
          { name: '最新资讯', url: 'https://www.kaiyun.com/articles' },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-16">
          <Breadcrumb items={[{ label: '最新资讯' }]} />

          <main>
            <section className="py-16 md:py-20 bg-background-100">
              <div className="max-w-7xl mx-auto px-4 md:px-6">
                <div className="text-center mb-12">
                  <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                    最新<strong className="text-primary-500">资讯</strong>
                  </h1>
                  <p className="text-secondary-600 max-w-2xl mx-auto">
                    了解开云平台最新动态、安全公告、优惠活动与技术更新
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                  {articles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/articles/${article.id}`}
                      className="group rounded-xl bg-background-50 border border-background-200/50 overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
                    >
                      <div className="relative h-48 overflow-hidden">
                        <img
                          src={articleImages[article.id]}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-5">
                        <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500/10 text-accent-600 mb-3 whitespace-nowrap">
                          {article.categoryName}
                        </span>
                        <h2 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                          {article.title}
                        </h2>
                        <p className="text-sm text-secondary-600 leading-relaxed line-clamp-2 mb-4">
                          {article.summary}
                        </p>
                        <div className="flex items-center justify-between text-xs text-secondary-500">
                          <span>{article.date}</span>
                          <span>{article.readTime} 阅读</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </section>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
}